import { render, staticRenderFns } from "./Reselling.vue?vue&type=template&id=1320f6e0&scoped=true&"
import script from "./Reselling.vue?vue&type=script&lang=js&"
export * from "./Reselling.vue?vue&type=script&lang=js&"
import style0 from "./Reselling.vue?vue&type=style&index=0&id=1320f6e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1320f6e0",
  null
  
)

export default component.exports